var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCancelledOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59,
    height: 75,
    viewBox: "0 0 59 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "6elpxthhha",
    d: "M0 0.695L57.713 0.695 57.713 73.282 0 73.282z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-937 -415) translate(937.5 415) translate(0 .023)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "eaxbyiq59b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6elpxthhha"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BE00",
    d: "M47.114 49.267C34.78 68.123 16.594 77.912 6.518 71.13c-10.088-6.771-8.266-27.56 4.08-46.419C22.94 5.862 41.117-3.935 51.194 2.844c10.088 6.776 8.267 27.56-4.081 46.423",
    mask: "url(#eaxbyiq59b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M49.24 20.034c0 1.873-1.517 3.393-3.39 3.393-1.87 0-3.39-1.52-3.39-3.393 0-1.873 1.52-3.391 3.39-3.391 1.873 0 3.39 1.518 3.39 3.39",
    transform: "translate(-937 -415) translate(937.5 415)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M36.517 30.932l-6.106 6.107 6.106 6.107c.452.45.45 1.184-.001 1.635-.453.453-1.185.453-1.636.001l-6.107-6.107-6.106 6.106c-.452.453-1.186.453-1.638 0-.452-.452-.452-1.184 0-1.636l6.106-6.106-6.106-6.107c-.452-.451-.452-1.184 0-1.637.452-.452 1.186-.452 1.637 0l6.107 6.106 6.107-6.106c.451-.452 1.183-.452 1.636 0 .453.452.453 1.185.001 1.637m-7.744 20.012c-7.68 0-13.905-6.227-13.905-13.905 0-7.679 6.225-13.906 13.905-13.906S42.68 29.36 42.68 37.04c0 7.678-6.226 13.905-13.906 13.905m0-30.129c-8.96 0-16.222 7.263-16.222 16.224 0 8.959 7.263 16.223 16.222 16.223 8.96 0 16.224-7.264 16.224-16.223 0-8.96-7.265-16.224-16.224-16.224",
    transform: "translate(-937 -415) translate(937.5 415)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelledOrder);
export default __webpack_public_path__ + "static/media/icon_cancelled_order.87e2191650e825db62798d791770f65e.svg";
export { ForwardRef as ReactComponent };